import { formatDate } from '@findy-code/utils/date';
import { useMemo } from 'react';

import type { DateTimeProps } from './date-time.types';

export const DateTime = ({ dateTime, format, ...rest }: DateTimeProps) => {
  const convertedDateTime = useMemo(
    () => formatDate(dateTime, format),
    [dateTime, format]
  );

  return (
    <time dateTime={dateTime} {...rest}>
      {convertedDateTime}
    </time>
  );
};
